import { render, staticRenderFns } from "./adb-button.vue?vue&type=template&id=b2846256&scoped=true&"
import script from "./adb-button.vue?vue&type=script&lang=js&"
export * from "./adb-button.vue?vue&type=script&lang=js&"
import style0 from "./adb-button.vue?vue&type=style&index=0&id=b2846256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2846256",
  null
  
)

export default component.exports